"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalPointerEventCapturer = void 0;
/**
 * This class manages adding and removing global (window) event handler's for touch/mouse move and up and capturing
 * the events if need be (on IE).
 *
 * This is useful for implementing drag behavior.  If you rely on element level move and up events, you will only
 * get those if the user's mouse pointer or finger stayed within the bounds of the element.  As soon as they move
 * outside the element (or outside the browser) you won't get them.
 */
var GlobalPointerEventCapturer = /** @class */ (function () {
    function GlobalPointerEventCapturer(
    // We need this elementRef solely for IE, see comments about set and release capture below
    elementRef, onPointerMove, onPointerUp) {
        this.listenersAdded = false;
        this.elementRef = elementRef;
        this.onPointerMove = onPointerMove;
        this.onPointerUp = onPointerUp;
    }
    GlobalPointerEventCapturer.prototype.addListeners = function () {
        if (this.listenersAdded) {
            return;
        }
        window.addEventListener('touchend', this.onPointerUp, true);
        window.addEventListener('mouseup', this.onPointerUp, true);
        // `passive: false` necessary for TFSID 798261 + https://bugs.webkit.org/show_bug.cgi?id=182521
        window.addEventListener('touchmove', this.onPointerMove, { capture: true, passive: false });
        window.addEventListener('mousemove', this.onPointerMove, { capture: true, passive: false });
        // On IE we have to setCapture the element so that if the mouse goes outside the bounds of the page, we will still
        // get mousemove and mouseup events.
        // tslint:disable-next-line:no-any
        if (this.elementRef.setCapture) {
            // tslint:disable-next-line:no-any
            this.elementRef.setCapture();
        }
        this.listenersAdded = true;
    };
    GlobalPointerEventCapturer.prototype.removeListeners = function () {
        if (!this.listenersAdded) {
            return;
        }
        window.removeEventListener('touchend', this.onPointerUp, true);
        window.removeEventListener('mouseup', this.onPointerUp, true);
        window.removeEventListener('touchmove', this.onPointerMove, { capture: true });
        window.removeEventListener('mousemove', this.onPointerMove, { capture: true });
        // We have to releaseCapture on IE since we setCapture there
        // tslint:disable-next-line:no-any
        if (this.elementRef.releaseCapture) {
            // tslint:disable-next-line:no-any
            this.elementRef.releaseCapture();
        }
        this.listenersAdded = false;
    };
    return GlobalPointerEventCapturer;
}());
exports.GlobalPointerEventCapturer = GlobalPointerEventCapturer;
//# sourceMappingURL=GlobalPointerEventCapturer.js.map